const ADD_BREADCRUMB_ITEM = 'ADD_BREADCRUMB_ITEM';
const ADD_CATALOG_BREADCRUMB = 'ADD_CATALOG_BREADCRUMB';
const REMOVE_BREADCRUMB_ITEM = 'REMOVE_BREADCRUM_ITEM';
const SET_SELECTED = 'SET_SELECTED';
const SET_DEFAULT = 'SET_DEFAULT';
const REMOVE_ITEMS_FROM_INDEX = 'REMOVE_ITEMS_FROM_INDEX';
const CLEAN_SELECTED = 'CLEAN_SELECTED';
const SET_BREADCRUMB_TITLE = 'SET_BREADCRUMB_TITLE';
const SET_BREADCRUMB_FROM_URL = 'SET_BREADCRUMB_FROM_URL';
const FILL_BREADCRUMB = 'FILL_BREADCRUMB';

export const addBreadcrumbItem = (item, index) => ({
    type: ADD_BREADCRUMB_ITEM,
    item,
    index
});

export const addCatalogBreadcrumb = (item, language) => ({
    type: ADD_CATALOG_BREADCRUMB,
    item,
    language
});

export const fillBreadcrumb = (firstItem, breadcrumb, urlBreadcrumb, language) => ({
    type: FILL_BREADCRUMB,
    firstItem,
    breadcrumb,
    urlBreadcrumb,
    language
});

export const setSelected = selected => ({
    type: SET_SELECTED,
    selected
});

export const cleanSelected = () => ({
    type: CLEAN_SELECTED
});

export const setDefault = (item, language) => ({
    type: SET_DEFAULT,
    item,
    language
});

export const setBreadcrumbTitle = (item, language) => ({
    type: SET_BREADCRUMB_TITLE,
    item,
    language
});

export const setBreadcrumbFromUrl = breadcrumb => ({
    type: SET_BREADCRUMB_FROM_URL,
    breadcrumb
});

export const removeFromIndex = index => ({
    type: REMOVE_ITEMS_FROM_INDEX, index
});

const pushItem = (state, item, index) => {

    const REMOVE_NO_ITEMS = 0;
    const ret = state.breadcrumb.find(element => element.id === item.id);

    if (ret) {
        return state.breadcrumb;
    }

    if (index) {

        state.breadcrumb.splice(index, REMOVE_NO_ITEMS, item);

        return state.breadcrumb;
    }
    state.breadcrumb.push(item);

    return state.breadcrumb;


};

const pushBreadcrumb = (state, firstItem, breadcrumb, urlBreadcrumb) => {
    if (urlBreadcrumb.length) {
        return [firstItem, ...breadcrumb];
    }

    return state.breadcrumb;

};

const pushCatalog = (state, item) => {
    const INDEX = 1;
    const REMOVE_NO_ITEMS = 0;

    const ret = state.breadcrumb.find(element => element.id === item.id);

    if (ret) {
        return state.breadcrumb;
    }
    state.breadcrumb.splice(INDEX, REMOVE_NO_ITEMS, item);


    return state.breadcrumb;
};

const pushTitle = (state, item) => {
    const INDEX = 0;
    const REMOVE_ONE_ITEM = 1;

    state.breadcrumb.splice(INDEX, REMOVE_ONE_ITEM, item);

    return state.breadcrumb;
};
const removeElements = (state, index) => {
    state.breadcrumb.splice(index);

    return state.breadcrumb;
};


const _defaultState = () => ({
    breadcrumb:    [{name: ''}],
    urlBreadcrumb: []
});

export const reducer = (state = _defaultState(), action = '') => {
    switch (action.type) {
    case ADD_BREADCRUMB_ITEM:
        return {
            ...state,
            breadcrumb: pushItem(state, action.item, action.index)
        };
    case ADD_CATALOG_BREADCRUMB:
        return {
            ...state,
            breadcrumb: pushCatalog(state, action.item)
        };
    case REMOVE_BREADCRUMB_ITEM:
        return {
            ...state,
            breadcrumb: pushItem(state, action.item)
        };
    case REMOVE_ITEMS_FROM_INDEX:
        return {
            ...state,
            breadcrumb: removeElements(state, action.index)
        };
    case SET_DEFAULT:
        return {
            ...state,
            breadcrumb:         [action.item],
            breadcrumbLanguage: action.breadcrumbLanguage
        };
    case SET_SELECTED:
        return {
            ...state,
            selected: {
                categoryId:   action.selected.id,
                categoryName: action.selected.name,
                catalogId:    action.selected.catalog.id,
                catalogName:  action.selected.catalog.name
            }
        };
    case SET_BREADCRUMB_TITLE:
        return {
            ...state,
            breadcrumb:         pushTitle(state, action.item),
            breadcrumbLanguage: action.language
        };
    case SET_BREADCRUMB_FROM_URL:
        return {
            ...state,
            urlBreadcrumb: action.breadcrumb
        };
    case CLEAN_SELECTED:
        return {
            ...state,
            selected: null
        };
    case FILL_BREADCRUMB:
        return {
            ...state,
            breadcrumb: pushBreadcrumb(
                state,
                action.firstItem,
                action.breadcrumb,
                action.urlBreadcrumb
            ),
            breadcrumbLanguage: action.language
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/catalogRequest.js